import {
  Group,
  GroupAction as Action,
  GroupActionTypes as ActionTypes,
  GroupsList,
  GroupsListInfo,
  SelectMembersList,
  SelectMembersListInfo,
} from './types';

export const init = (): Action => ({ type: ActionTypes.INIT });

export const refresh = (): Action => ({ type: ActionTypes.REFRESH });

export const setIsLoading = (isLoading: boolean): Action => ({
  type: ActionTypes.LOADING,
  payload: isLoading,
});

export const setIsLoading2 = (isLoading2: boolean): Action => ({
  type: ActionTypes.LOADING2,
  payload: isLoading2,
});

export const setIsSubmitting = (isSubmitting: boolean): Action => ({
  type: ActionTypes.SUBMITTING,
  payload: isSubmitting,
});

/**
 * @summary 画面遷移処理の実行フラグをセットする
 * @param {boolean} isNavigating 遷移処理を実行するか
 * @returns {Action}
 */
export const setIsNavigating = (isNavigating: boolean): Action => ({
  type: ActionTypes.NAVIGATING,
  payload: isNavigating,
});

/**
 * @summary 遷移先のURLをセットする
 * @param {string | null} navigateTo 遷移させるURL
 * @returns {Action}
 */
export const setNavigateTo = (navigateTo: string | null): Action => ({
  type: ActionTypes.SET_NAVIGATE_TO,
  payload: navigateTo,
});

export const setGroups = (groups: GroupsList[]): Action => ({
  type: ActionTypes.SET_GROUPS,
  payload: groups,
});

export const setGroupsListInfo = (info: GroupsListInfo | null): Action => ({
  type: ActionTypes.SET_GROUPS_LIST_INFO,
  payload: info,
});

export const setGroup = (group: Group | null): Action => ({
  type: ActionTypes.SET_GROUP,
  payload: group,
});

export const setSelectMembers = (selectMembers: SelectMembersList[]): Action => ({
  type: ActionTypes.SET_SELECT_MEMBERS,
  payload: selectMembers,
});

export const setSelectMembersListInfo = (info: SelectMembersListInfo | null): Action => ({
  type: ActionTypes.SET_SELECT_MEMBERS_LIST_INFO,
  payload: info,
});
